import { isEmptyValue } from '../managerUtils';
import { LAYOUT_MATRIX_IDENTITY_FIELDS } from '../../constants';
import { LayoutObject } from '../../types/types';

// What item a layout object points at: the identity keys it carries (stulid /
// rcptid) with their values. Number 101 and string '101' are the same reference,
// so the value is stringified. No identity key at all → null, the object can
// never be paired with another one.
export const getMatrixObjectIdentity = (
  object: LayoutObject
): string | null => {
  const names = LAYOUT_MATRIX_IDENTITY_FIELDS.filter(
    (name) => !isEmptyValue(object[name])
  );

  if (names.length === 0) {
    return null;
  }

  return names.map((name) => `${name}:${String(object[name])}`).join('|');
};
